// Locale-aware formatting (WEB-F-SH-04). Units come from /meta and the user's preference from M2 on; until then
// only numbers, dates and relative times are formatted here.
export function formatNumber(value: number, lang: string, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(lang, options).format(value);
}

export function formatDateTime(value: Date | string, lang: string): string {
  const d = typeof value === "string" ? new Date(value) : value;
  return new Intl.DateTimeFormat(lang, { dateStyle: "medium", timeStyle: "short" }).format(d);
}

/** "2 minutes ago", "in 3 hours": the age indicator next to every value (WEB-F-RND-03). */
export function formatAge(value: Date | string, lang: string, now: Date = new Date()): string {
  const d = typeof value === "string" ? new Date(value) : value;
  const seconds = Math.round((d.getTime() - now.getTime()) / 1000);
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });
  const abs = Math.abs(seconds);
  if (abs < 60) return rtf.format(seconds, "second");
  if (abs < 3600) return rtf.format(Math.round(seconds / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(seconds / 3600), "hour");
  return rtf.format(Math.round(seconds / 86400), "day");
}

/** "27 October": a day without the time, for dates such as when access ends. */
export function formatDay(value: Date | string, lang: string): string {
  const d = typeof value === "string" ? new Date(value) : value;
  return new Intl.DateTimeFormat(lang, { day: "numeric", month: "long" }).format(d);
}
